import { forwardRef } from 'react';
import TableBaseButton from './TableBaseButton';

interface DeleteButtonProps {
  onClick: () => void;
  ref?: React.Ref<HTMLButtonElement>;
  onKeyDown?: (e: React.KeyboardEvent<HTMLButtonElement>) => void;
}

const DeleteButton = forwardRef<HTMLButtonElement, DeleteButtonProps>(
  ({ onClick, onKeyDown }, ref) => {
    return (
      <TableBaseButton
        onClick={onClick}
        variant="danger"
        buttonText="削除"
        ref={ref}
        onKeyDown={onKeyDown}
      />
    );
  }
);

DeleteButton.displayName = 'DeleteButton';
export default DeleteButton;
